export const INITIAL = {
  VALUES: { billet_one: 100 },
}
